export enum OverviewType {
    JOBS = 'JOBS',
    MENTORING = 'MENTORING',
    VOLUNTEERING = 'VOLUNTEERING',
    SKILLS = 'SKILLS',
    ORGANISATIONS = 'ORGANISATIONS',
    VOLUNTEERS = 'VOLUNTEERS',
    TALENT_BASE = 'TALENT_BASE',
    PAGES = 'PAGES'
}
